import Img1 from "../assets/images/training.jpg";
import Img2 from "../assets/images/project.jpeg";
import Img3 from "../assets/images/solid.jpg";
import Img4 from "../assets/images/chemistry2.png";
import Img5 from "../assets/images/com.png";
import Img6 from "../assets/images/logic.jpg";
import Img7 from "../assets/images/algebra.jpg";
import Img8 from "../assets/images/geometry.jpg";
import Img9 from "../assets/images/matter.jpg";
import Img11 from "../assets/images/chemistry.webp";
import Img10 from "../assets/images/biology.jpeg";
import Img12 from "../assets/images/computer.webp";
import Img13 from "../assets/images/culture.webp";
import Img14 from "../assets/images/planet.jpeg";
import Img15 from "../assets/images/geology.jpg";
import Img16 from "../assets/images/geometry2.jpg";
import Img17 from "../assets/images/glp.jpg";
import Img18 from "../assets/images/electricity.jpg";
import Img19 from "../assets/images/biology2.jpeg";
import Img20 from "../assets/images/program.jpeg";
import Img21 from "../assets/images/linear.png";
import Img22 from "../assets/images/labwork.png";
import Img23 from "../assets/images/earth2.jpeg";
import Img24 from "../assets/images/waves.jpeg";
import Img25 from "../assets/images/stat.png";
import Img26 from "../assets/images/modern.jpg";
import Img27 from "../assets/images/photo.jpg";
import Img28 from "../assets/images/energy.jpeg";
import Img29 from "../assets/images/service.jpeg";
import Img30 from "../assets/images/vector.png";
import Img31 from "../assets/images/equation.png";
import Img32 from "../assets/images/thermal.webp";
import Img33 from "../assets/images/glp.jpg";
import Img34 from "../assets/images/quantum.webp";
import Img35 from "../assets/images/math-physics.jpg";
import Img36 from "../assets/images/analytical.jpeg";
import Img37 from "../assets/images/glass.jpg";
import Img38 from "../assets/images/history.png";
import Img39 from "../assets/images/structure.jpeg";
import Img40 from "../assets/images/entre.jpeg";
import Img41 from "../assets/images/magnet.jpg";
import Img42 from "../assets/images/analytical.jpg";
import Img43 from "../assets/images/electronics.jpeg";
import Img44 from "../assets/images/applied.jpeg";
import Img45 from "../assets/images/geo.jpg";
import Img46 from "../assets/images/training.jpg";
import Img47 from "../assets/images/project.jpeg";
import Img48 from "../assets/images/compute.webp";
import Img49 from "../assets/images/optics.png";
import Img50 from "../assets/images/tech.png";
import Img51 from "../assets/images/data.jpeg";
import Img52 from "../assets/images/meter.jpg";
import Img53 from "../assets/images/cos.jpg";
import Img54 from "../assets/images/gis.png";
import Img55 from "../assets/images/fluid.webp";
import Img56 from "../assets/images/environment.jpeg";
import Img57 from "../assets/images/radiation.webp";
import Img58 from "../assets/images/semi-conduct.png";
import Img59 from "../assets/images/solar.webp";
import Img60 from "../assets/images/material.jpeg";
import Img61 from "../assets/images/electro.jpeg";
import Img62 from "../assets/images/workshop.jpeg";
import Img63 from "../assets/images/thermo.jpeg";
import Img64 from "../assets/images/nuclear.png";
import Img65 from "../assets/images/plasma.jpeg";
import Img66 from "../assets/images/theory.jpeg";
import Img67 from "../assets/images/meter.png";
import Img68 from "../assets/images/model.jpg";
import Img69 from "../assets/images/interior.jpeg";
import Img70 from "../assets/images/field.jpg";
import Img71 from "../assets/images/electro2.png";
import Img72 from "../assets/images/seismic.jpg";
import Img73 from "../assets/images/borehole.jpeg";
import Img75 from "../assets/images/geophysical.jpeg";
import Img76 from "../assets/images/prospect.webp";
import Img78 from "../assets/images/paleo.jpeg";
import Img79 from "../assets/images/instrument.jpeg";
import Img80 from "../assets/images/mech.jpeg";
import Img81 from "../assets/images/materials.jpeg";
import Img82 from "../assets/images/electromet.webp";
import Img83 from "../assets/images/powder.jpg";
import Img84 from "../assets/images/nano.jpeg";
import Img85 from "../assets/images/ceramics.webp";
import Img86 from "../assets/images/Ionizing.png";
import Img87 from "../assets/images/soil.webp";
import Img88 from "../assets/images/cable.jpg";
import Img89 from "../assets/images/corosion.jpg";
import Img90 from "../assets/images/environment2.jpeg";

export const popularCourses = [
  {
    courseTitle: "Introduction to Electricity & Magnetism",
    img: Img18,
    courseDetail:
      "This course explores the fundamental principles of motion, including Newtonian mechanics and Lagrangian dynamics.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    courseCode: "PHY 112.2",
  },
  {
    courseTitle: "Modern Cosmology and High Energy Astrophysics",
    img: Img53,
    courseDetail:
      "Students learn about electric and magnetic fields, Maxwell's equations, and the behavior of electromagnetic waves",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    courseCode: "PHY 420.2",
  },
  {
    courseTitle: "Solid State Physics II",
    img: Img3,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    courseCode: "PHY 443.2",
  },
];
export const allCourses = [
  {
    courseTitle: "General Chemistry",
    img: Img4,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year1", "unitload3", "compulsory"],
    courseCode: "CHM 130.1",
  },
  {
    courseTitle: "Communication Skill in Eng.",
    img: Img5,
    courseDetail:
      "This course covers the properties of light, geometric optics, wave optics, and modern optical technologies",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year1", "unitload3", "compulsory"],
    courseCode: "GES 100.1",
  },
  {
    courseTitle: "Intro. To Logic & Philosophy",
    img: Img6,
    courseDetail:
      "Students explore the structure of atomic nuclei, nuclear reactions, and applications in nuclear technology.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year1", "unitload2", "compulsory"],
    courseCode: "GES 102.1",
  },
  {
    courseTitle: "Algebra & Trigonometry",
    img: Img7,
    courseDetail:
      "This course launches the students into the basic and initial concept of physics and it's dynamisms. It is a foundation forming aspect of physics",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year1", "unitload3", "compulsory"],
    courseCode: "MTH 110.1",
  },
  {
    courseTitle: "Coordinate Geometry/Calculus",
    img: Img8,
    courseDetail:
      "This course investigates the properties of solids, crystal structures, and the behavior of electrons in solids",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year1", "unitload3", "compulsory"],
    courseCode: "MTH 120.1",
  },
  {
    courseTitle: "Introduction to Mech.& Properties of Matter",
    img: Img9,
    courseDetail:
      "Students study the universe, its origins, and the physical processes that govern celestial bodies and the cosmos",
    courseHandler: "M.S. Nawaz",
    unitLoad: "1",
    category: ["year1", "unitload1", "compulsory"],
    courseCode: "PHY 101.1",
  },
  {
    courseTitle: "General Biology I",
    img: Img10,
    courseDetail:
      "A practical course that focuses on laboratory techniques, data analysis, and conducting experiments in various physics disciplines.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year1", "unitload2", "compulsory"],
    courseCode: "FSB 101.1",
  },
  {
    courseTitle: "General Chemistry",
    img: Img11,
    courseDetail:
      "An advanced course that delves into the principles of relativistic quantum field theory, often a prerequisite for particle physics.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year1", "unitload3", "compulsory"],
    courseCode: "CHM 131.2",
  },
  {
    courseTitle: "Computer Appreciation ",
    img: Img12,
    courseDetail:
      "This course provides the mathematical tools necessary for advanced physics research and problem-solving",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year1", "unitload2", "compulsory"],
    courseCode: "GES 101.2",
  },
  {
    courseTitle: "Nigerian People & Culture",
    img: Img13,
    courseDetail:
      "Students explore the fundamental particles of the universe and the forces that govern their interactions",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year1", "unitload2", "compulsory"],
    courseCode: "GES 103.2",
  },
  {
    courseTitle: "Planet Earth",
    img: Img14,
    courseDetail:
      "A deeper dive into the properties and behavior of condensed matter systems, including solids and liquids",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year1", "unitload3", "compulsory"],
    courseCode: "GLY 101.2",
  },
  {
    courseTitle: "Introduction to Lab/Field Practice in Geology",
    img: Img15,
    courseDetail:
      "This course covers Einstein's theory of general relativity, which describes the gravitational interactions between massive objects.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "1",
    category: ["year1", "unitload1", "compulsory"],
    courseCode: "GLY 102.2",
  },
  {
    courseTitle: "Coordinate Geometry",
    img: Img16,
    courseDetail:
      "Students study the structure and behavior of atoms and molecules, including spectroscopy.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year1", "unitload3", "compulsory"],
    courseCode: "MTH 124.2",
  },
  {
    courseTitle: "Laboratory Practice II",
    img: Img17,
    courseDetail:
      "This course focuses on the behavior of ionized gases, such as those found in stars, fusion reactors, and astrophysical environments",
    courseHandler: "M.S. Nawaz",
    unitLoad: "1",
    category: ["year1", "unitload1", "compulsory"],
    courseCode: "PHY 103.2",
  },
  {
    courseTitle: "Introduction to Electricity & Magnetism",
    img: Img18,
    courseDetail:
      "An interdisciplinary course that applies the principles of physics to biological systems and processes.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year1", "unitload3", "compulsory"],
    courseCode: "PHY 112.2",
  },
  {
    courseTitle: "General Biology II",
    img: Img19,
    courseDetail:
      "Explores the application of physics to environmental issues, including climate science and sustainable energy solutions.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year1", "unitload3", "compulsory"],
    courseCode: "FSB 102.2",
  },
  /////////////////////////////////////////////YEAR TWO BELOW
  {
    courseTitle: "Computer Programming",
    img: Img20,
    courseDetail:
      "Teaches students how to use computer simulations and numerical methods to solve complex physics problems",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year2", "unitload3", "compulsory"],
    courseCode: "CSC 280.1",
  },
  {
    courseTitle: "Linear Algebra",
    img: Img21,
    courseDetail:
      "Courses that cover emerging or specialized areas of physics, such as quantum computing, nanotechnology, or high-energy astrophysics.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year2", "unitload3", "compulsory"],
    courseCode: "MTH 210.1",
  },
  {
    courseTitle: "Laboratory Practice III",
    img: Img22,
    courseDetail:
      "Students learn about electric and magnetic fields, Maxwell's equations, and the behavior of electromagnetic waves",
    courseHandler: "M.S. Nawaz",
    unitLoad: "1",
    category: ["year2", "unitload1", "compulsory"],
    courseCode: "PHY 206.1",
  },
  {
    courseTitle: "Physics of the Solid Earth",
    img: Img23,
    courseDetail:
      "There are many variations of sages of Lorem Ipsum available, but the mrity have suffered alteration in some orm, by injected humo ur,There are many but the mri have suffered alteration in some",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year2", "unitload2", "compulsory"],
    courseCode: "PHY 210.1",
  },
  {
    courseTitle: "Vibrations & Waves",
    img: Img24,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year2", "unitload3", "compulsory"],
    courseCode: "PHY 216.1",
  },
  {
    courseTitle: "Introduction to Probability & Statistics",
    img: Img25,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year2", "unitload3", "compulsory"],
    courseCode: "STA 260.1",
  },
  {
    courseTitle: "Modern Physics",
    img: Img26,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year2", "unitload2", "compulsory"],
    courseCode: "PHY 231.1",
  },
  {
    courseTitle: "Photography and Illustration",
    img: Img27,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "1",
    category: ["year2", "unitload1", "compulsory"],
    courseCode: "SLT 201.1 ",
  },
  {
    courseTitle: "Energy, Environment and Space Science",
    img: Img28,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year2", "unitload2", "compulsory"],
    courseCode: "PHY 200.2 ",
  },
  {
    courseTitle: "Community Service",
    img: Img29,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "1",
    category: ["year2", "unitload1", "compulsory"],
    courseCode: "FCS  2C1.2 ",
  },
  {
    courseTitle: "Vector Analysis",
    img: Img30,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year2", "unitload3", "compulsory"],
    courseCode: "MTH 240.2",
  },
  {
    courseTitle: "Elem. Differential Equation",
    img: Img31,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year2", "unitload3", "compulsory"],
    courseCode: "MTH 250.2",
  },
  {
    courseTitle: "Thermal Physics",
    img: Img32,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year2", "unitload3", "compulsory"],
    courseCode: "PHY 205.2",
  },
  {
    courseTitle: "Laboratory practice IV",
    img: Img33,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "1",
    category: ["year2", "unitload1", "compulsory"],
    courseCode: "PHY 207.2",
  },
  {
    courseTitle: "Quantum Mechanics I",
    img: Img34,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year2", "unitload2", "compulsory"],
    courseCode: "PHY 211.1",
  },
  {
    courseTitle: "Mathematical Physics",
    img: Img35,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year2", "unitload2", "compulsory"],
    courseCode: "PHY 221.2",
  },
  {
    courseTitle: "Analytical mechanics I",
    img: Img36,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year2", "unitload2", "compulsory"],
    courseCode: "PHY 222.2",
  },
  {
    courseTitle: "Workshop Technology II (Glass Blowing)",
    img: Img37,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "1",
    category: ["year2", "unitload1", "compulsory"],
    courseCode: "SLT 210.2",
  },
  {
    courseTitle: "Stratigraphy & Historical Geology",
    img: Img38,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year2", "unitload2", "elective"],
    courseCode: "GLY 201.1",
  },
  {
    courseTitle: "Structural Geology",
    img: Img39,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year2", "unitload2", "elective"],
    courseCode: "GLY 202.1",
  },
  {
    courseTitle: "Entrepreneurship",
    img: Img40,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year3", "unitload2", "compulsory"],
    courseCode: "GES 300.1",
  },
  {
    courseTitle: "Mathematical Physics II",
    img: Img35,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year3", "unitload2", "compulsory"],
    courseCode: "PHY 300.1",
  },
  {
    courseTitle: "Electricity & Magnetism I",
    img: Img41,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year3", "unitload2", "compulsory"],
    courseCode: "PHY 313.1",
  },
  {
    courseTitle: "Analytical Physics II",
    img: Img42,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year3", "unitload2", "compulsory"],
    courseCode: "PHY 322.1",
  },
  {
    courseTitle: "Quantum Mechanics II",
    img: Img34,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year3", "unitload2", "compulsory"],
    courseCode: "PHY 331.1",
  },
  {
    courseTitle: "Electronics I",
    img: Img43,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year3", "unitload2", "compulsory"],
    courseCode: "PHY 351.1",
  },
  {
    courseTitle: "Introduction to Applied Geophysics",
    img: Img44,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year3", "unitload2", "compulsory"],
    courseCode: "PHY 361.1",
  },
  {
    courseTitle: "Geophysical Exploration I",
    img: Img45,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year3", "unitload2", "compulsory"],
    courseCode: "PHY 362.1",
  },
  {
    courseTitle: "Industrial Training",
    img: Img46,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "9",
    category: ["year3", "unitload9", "compulsory"],
    courseCode: "PHY 350.2",
  },
  ///////////////YEAR FOUR BELOW
  {
    courseTitle: "Entrepreneurship Project",
    img: Img47,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year3", "unitload2", "compulsory"],
    courseCode: "GES 400.1",
  },
  {
    courseTitle: "Computational Physics & Numerical Methods ",
    img: Img48,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year4", "unitload3", "compulsory"],
    courseCode: "PHY 408.1",
  },
  {
    courseTitle: "Physical Optics ",
    img: Img49,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year4", "unitload3", "compulsory"],
    courseCode: "PHY 409.1",
  },
  {
    courseTitle: "Technical Writing",
    img: Img50,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "1",
    category: ["year4", "unitload1", "compulsory"],
    courseCode: "PHY 412.1",
  },
  {
    courseTitle: "Elect. & Magnetism II",
    img: Img41,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year4", "unitload2", "compulsory"],
    courseCode: "PHY 414.1",
  },
  {
    courseTitle: "Solid State Physics I",
    img: Img3,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year4", "unitload3", "compulsory"],
    courseCode: "PHY 442.1",
  },
  {
    courseTitle: "Geophysical Data Processing II",
    img: Img51,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year4", "unitload3", "compulsory"],
    courseCode: "PHY 461.1",
  },
  {
    courseTitle: "Geophysical Exploration II: Other Methods",
    img: Img45,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year4", "unitload3", "compulsory"],
    courseCode: "PHY 462.1",
  },
  {
    courseTitle: "Solid State Physics II",
    img: Img3,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year4", "unitload3", "compulsory"],
    courseCode: "PHY 443.2",
  },
  {
    courseTitle: "Project Work",
    img: Img47,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "6",
    category: ["year4", "unitload6", "compulsory"],
    courseCode: "PHY 449.2",
  },
  {
    courseTitle: "Seminar in Geophysics",
    img: Img45,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year4", "unitload3", "compulsory"],
    courseCode: "PHY 450.2",
  },
  {
    courseTitle: "Geophysics Data Processing II",
    img: Img51,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year4", "unitload3", "compulsory"],
    courseCode: "PHY 463.2",
  },
  {
    courseTitle: "Geophysics Practical Methods",
    img: Img45,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "1",
    category: ["year4", "unitload1", "compulsory"],
    courseCode: "PHY 464.2",
  },
  {
    courseTitle: "Statistical Physics",
    img: Img25,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["year4", "unitload3", "compulsory"],
    courseCode: "PHY 490.2",
  },
  {
    courseTitle: "Meteorology",
    img: Img52,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year4", "unitload2", "elective"],
    courseCode: "PHY 418.2",
  },
  {
    courseTitle: "Modern Cosmology and High Energy Astrophysics",
    img: Img53,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year4", "unitload2", "elective"],
    courseCode: "PHY 420.2",
  },
  {
    courseTitle: "Geographic and Information System",
    img: Img54,
    courseDetail:
      "This course delves into the principles of quantum mechanics, wave functions, operators, and the behavior of particles at the quantum level",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["year4", "unitload2", "elective"],
    courseCode: "GEM 306.1",
  },
];
export const PGDCourses = [
  {
    courseTitle: "ICT and research methodology",
    img: Img48,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["diploma1", "unitload2", "compulsory"],
    courseCode: "PHY 750.1",
  },
  {
    courseTitle: "Vibration and waves",
    img: Img24,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "compulsory"],
    courseCode: "PHY 700.1",
  },
  {
    courseTitle: "Mathematical physics",
    img: Img35,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "compulsory"],
    courseCode: "PHY 701.1",
  },
  {
    courseTitle: "Thermodynamics and statistical physics",
    img: Img25,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "compulsory"],
    courseCode: "PHY 702.1",
  },
  {
    courseTitle: "Geometric and physical optics",
    img: Img49,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "compulsory"],
    courseCode: "PHY 703.1",
  },
  {
    courseTitle: "Atomic, Nuclear and Modern Physics",
    img: Img26,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["diploma1", "unitload2", "compulsory"],
    courseCode: "PHY 704.1",
  },
  {
    courseTitle: "Advanced Laboratory Practice",
    img: Img33,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["diploma1", "unitload2", "compulsory"],
    courseCode: "PHY 705.1",
  },
  {
    courseTitle: "Management and entrepreneurship",
    img: Img40,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["diploma1", "unitload2", "compulsory"],
    courseCode: "PHY 751.2",
  },
  {
    courseTitle: "Electromagnetism (Electricity and magnetism)",
    img: Img18,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "compulsory"],
    courseCode: "PHY 706.2",
  },
  {
    courseTitle: "Solid State Physics",
    img: Img3,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["diploma1", "unitload2", "compulsory"],
    courseCode: "PHY 707.2",
  },

  {
    courseTitle: "Seminar",
    img: Img29,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["diploma1", "unitload2", "compulsory"],
    courseCode: "PHY 718.2",
  },

  {
    courseTitle: "Research Project	",
    img: Img47,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "4",
    category: ["diploma1", "unitload4", "compulsory"],
    courseCode: "PHY 719.2	",
  },
  {
    courseTitle: "Quantum Mechanics",
    img: Img34,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "elective"],
    courseCode: "PHY 708.2	",
  },
  {
    courseTitle: "Theoretical and fluid mechanics",
    img: Img55,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["diploma1", "unitload2", "elective"],
    courseCode: "PHY 709.2	",
  },
  {
    courseTitle: "Materials Science",
    img: Img55,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "elective"],
    courseCode: "PHY 710.2	",
  },
  {
    courseTitle: "Introduction to Geophysics",
    img: Img45,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "elective"],
    courseCode: "PHY 711.2	",
  },
  {
    courseTitle: "Geophysical prospecting methods",
    img: Img45,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["diploma1", "unitload2", "elective"],
    courseCode: "PHY 712.2		",
  },
  {
    courseTitle: "Introduction to Environmental Technology	",
    img: Img56,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "elective"],
    courseCode: "PHY 713.2			",
  },
  {
    courseTitle: "Non-Ionizing Radiations	",
    img: Img57,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["diploma1", "unitload2", "elective"],
    courseCode: "PHY 714.2				",
  },
  {
    courseTitle: "Electronics Instrumentation		",
    img: Img43,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "elective"],
    courseCode: "PHY 715.2					",
  },
  {
    courseTitle: "Physics of Semi-conductor Devices		",
    img: Img58,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "elective"],
    courseCode: "PHY 716.2					",
  },
  {
    courseTitle: "Thin film technology and solar materials		",
    img: Img59,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["diploma1", "unitload3", "elective"],
    courseCode: "PHY 717.2					",
  },
  {
    courseTitle: "ICT and research methodology",
    img: Img12,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["theory", "unitload2", "compulsory"],
    courseCode: "PHY 850.1					",
  },
  {
    courseTitle: "Mathematical Physics	",
    img: Img60,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["theory", "unitload3", "compulsory"],
    courseCode: "PHY 801.1					",
  },
  {
    courseTitle: "Advanced quantum mechanics &Applied Group Theory	",
    img: Img34,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["theory", "unitload3", "compulsory"],
    courseCode: "PHY 802.1				",
  },
  {
    courseTitle: "Electromagnetic theory	",
    img: Img61,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["theory", "unitload3", "compulsory"],
    courseCode: "PHY 803.1				",
  },
  {
    courseTitle: "Applied Electronic workshop		",
    img: Img62,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["theory", "unitload3", "compulsory"],
    courseCode: "PHY 804.1				",
  },
  {
    courseTitle: "Fluid dynamics and transport theory	",
    img: Img55,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["theory", "unitload2", "compulsory"],
    courseCode: "PHY 805.1				",
  },
  {
    courseTitle: "Thermodynamics and Statistical mechanics		",
    img: Img63,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["theory", "unitload2", "compulsory"],
    courseCode: "PHY 806.1					",
  },
  {
    courseTitle: "Management and entrepreneurship",
    img: Img40,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["theory", "unitload2", "compulsory"],
    courseCode: "PHY 851.2				",
  },
  {
    courseTitle: "Nuclear Physics and Instrumentation",
    img: Img64,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["theory", "unitload2", "compulsory"],
    courseCode: "PHY 851.2				",
  },
  {
    courseTitle: "Basic Plasma Physics and Space Science",
    img: Img65,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["theory", "unitload3", "compulsory"],
    courseCode: "PHY 808.2				",
  },
  {
    courseTitle: "Seminar in Advances in Theoretical Physics	",
    img: Img66,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["theory", "unitload3", "compulsory"],
    courseCode: "PHY 809.2						",
  },
  {
    courseTitle: "Research Project	",
    img: Img47,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "6",
    category: ["theory", "unitload6", "compulsory"],
    courseCode: "PHY 819.2					",
  },
  {
    courseTitle: "Numerical Methods and Computational Physics",
    img: Img48,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["theory", "unitload2", "elective"],
    courseCode: "PHY 810.2					",
  },
  {
    courseTitle: "Quantum Field Theories",
    img: Img34,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["theory", "unitload3", "elective"],
    courseCode: "PHY 811.2						",
  },
  {
    courseTitle: "Atmospheric physics and meteorology	",
    img: Img67,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["theory", "unitload3", "elective"],
    courseCode: "PHY 861.1							",
  },
  {
    courseTitle: "ICT and research methodology		",
    img: Img12,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["solid", "unitload2", "compulsory"],
    courseCode: "PHY 850.1								",
  },
  {
    courseTitle: "Mathematical Physics			",
    img: Img35,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["solid", "unitload3", "compulsory"],
    courseCode: "PHY 801.1									",
  },
  {
    courseTitle: "Advanced quantum mechanics &Applied Group Theory",
    img: Img34,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["solid", "unitload3", "compulsory"],
    courseCode: "PHY 802.1									",
  },
  {
    courseTitle: "Semi-conductor Physics	",
    img: Img58,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["solid", "unitload3", "compulsory"],
    courseCode: "PHY 812.1										",
  },
  {
    courseTitle: "Electronic instrumentation		",
    img: Img43,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["solid", "unitload3", "compulsory"],
    courseCode: "PHY 813.1										",
  },
  {
    courseTitle: "Applied electronics and Workshop practice		",
    img: Img62,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["solid", "unitload2", "compulsory"],
    courseCode: "PHY 814.1											",
  },
  {
    courseTitle: "Management and entrepreneurship			",
    img: Img40,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["solid", "unitload2", "compulsory"],
    courseCode: "PHY 851.2												",
  },
  {
    courseTitle: "Advanced solid state devices				",
    img: Img3,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["solid", "unitload3", "compulsory"],
    courseCode: "PHY 815.2													",
  },
  {
    courseTitle: "Physics of semi-conductor Devices			",
    img: Img58,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["solid", "unitload3", "compulsory"],
    courseCode: "PHY 816.2													",
  },
  {
    courseTitle: "Basic model concepts and manifest properties of solid			",
    img: Img68,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["solid", "unitload3", "compulsory"],
    courseCode: "PHY 817.2														",
  },
  {
    courseTitle: "Seminars			",
    img: Img29,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["solid", "unitload3", "compulsory"],
    courseCode: "PHY 818.2														",
  },
  {
    courseTitle: "Research project				",
    img: Img47,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "6",
    category: ["solid", "unitload6", "compulsory"],
    courseCode: "PHY 819.2														",
  },
  {
    courseTitle: "ICT and research methodology			",
    img: Img12,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["applied", "unitload2", "compulsory"],
    courseCode: "PHY 850.1															",
  },
  {
    courseTitle: "Mathematical Physics				",
    img: Img35,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["applied", "unitload3", "compulsory"],
    courseCode: "PHY 801.1																",
  },
  {
    courseTitle: "Physics of the Earth’s Interior	s				",
    img: Img69,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["applied", "unitload3", "compulsory"],
    courseCode: "PHY 820.1																",
  },
  {
    courseTitle: "Potential field theory		",
    img: Img70,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["applied", "unitload2", "compulsory"],
    courseCode: "PHY 821.1																	",
  },
  {
    courseTitle: "Electrical and electromagnetic method		",
    img: Img71,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["applied", "unitload2", "compulsory"],
    courseCode: "PHY 822.1",
  },
  {
    courseTitle: "Seismology Method (Reflection and Refraction)	",
    img: Img72,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["applied", "unitload3", "compulsory"],
    courseCode: "PHY 823.1	",
  },
  {
    courseTitle: "Borehole Geophysics and Radiometrics	",
    img: Img73,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["applied", "unitload2", "compulsory"],
    courseCode: "PHY 824.1		",
  },
  {
    courseTitle: "Management of entrepreneurship		",
    img: Img40,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["applied", "unitload2", "compulsory"],
    courseCode: "PHY 851.2		",
  },
  {
    courseTitle:
      "Time series Analysis, Digital Filter theory and data processing",
    img: Img51,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["applied", "unitload3", "compulsory"],
    courseCode: "PHY 825.2	",
  },
  {
    courseTitle: "Research seminar in Geophysics	",
    img: Img44,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["applied", "unitload2", "compulsory"],
    courseCode: "PHY 826.2	",
  },
  {
    courseTitle: "Geophysical field work",
    img: Img75,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "1",
    category: ["applied", "unitload1", "compulsory"],
    courseCode: "PHY 827.2		",
  },
  {
    courseTitle: "Research project in Geophysics	",
    img: Img47,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "6",
    category: ["applied", "unitload6", "compulsory"],
    courseCode: "PHY 828.2			",
  },
  {
    courseTitle: "Gravity and magnetic methods in Geophysics	",
    img: Img75,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["applied", "unitload2", "compulsory"],
    courseCode: "PHY 829.2				",
  },
  {
    courseTitle: "Numerical and Computational Methods",
    img: Img54,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["applied", "unitload2", "elective"],
    courseCode: "PHY 810.1					",
  },
  {
    courseTitle: "Geophysical Prospecting	",
    img: Img76,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["applied", "unitload3", "elective"],
    courseCode: "PHY 831.1						",
  },
  {
    courseTitle: "Geology for Non-Geologist (compulsory)		",
    img: Img15,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "0",
    category: ["applied", "unitload0", "elective"],
    courseCode: "PHY 834.1							",
  },
  {
    courseTitle: "Modelling in Geophysical Prospecting		",
    img: Img76,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["applied", "unitload2", "elective"],
    courseCode: "PHY 832.2								",
  },
  {
    courseTitle: "Principles of Paleo-magnetism",
    img: Img78,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "2",
    category: ["applied", "unitload2", "elective"],
    courseCode: "PHY 832.2								",
  },
  {
    courseTitle: "Geophysical Instrumentation",
    img: Img79,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
    unitLoad: "3",
    category: ["applied", "unitload3", "elective"],
    courseCode: "PHY 830.2									",
  },
  {
    courseCode: "PHY 801.1										",
    courseTitle: "Mathematical Physics",
    unitLoad: "3",
    category: ["material", "unitload3", "compulsory"],
    img: Img35,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 840.1",
    courseTitle: "Mechanical properties of materials	",
    unitLoad: "2",
    category: ["material", "unitload2", "compulsory"],
    img: Img80,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 841.1	",
    courseTitle: "Special engineering materials	",
    unitLoad: "3",
    category: ["material", "unitload3", "compulsory"],
    img: Img81,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 842.1	",
    courseTitle: "Thermodynamics of materials		",
    unitLoad: "3",
    category: ["material", "unitload3", "compulsory"],
    img: Img63,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 843.1	",
    courseTitle: "Electrometallurgy and materials degradation	",
    unitLoad: "2",
    category: ["material", "unitload2", "compulsory"],
    img: Img82,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 844.1	",
    courseTitle: "Powder Metallurgy and Processing		",
    unitLoad: "2",
    category: ["material", "unitload2", "compulsory"],
    img: Img83,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 844.1	",
    courseTitle: "Powder Metallurgy and Processing		",
    unitLoad: "2",
    category: ["material", "unitload2", "compulsory"],
    img: Img83,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 850.1	",
    courseTitle: "ICT and research methodology	",
    unitLoad: "2",
    category: ["material", "unitload2", "compulsory"],
    img: Img12,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 845.2		",
    courseTitle: "Thin film technology and solar materials	",
    unitLoad: "2",
    category: ["material", "unitload2", "compulsory"],
    img: Img59,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 846.2		",
    courseTitle: "Nano-materials and Nanotechnology	",
    unitLoad: "2",
    category: ["material", "unitload2", "compulsory"],
    img: Img84,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 847.2			",
    courseTitle: "Introduction to ceramics and polymer materials		",
    unitLoad: "2",
    category: ["material", "unitload2", "compulsory"],
    img: Img85,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 848.2	",
    courseTitle: "Seminar in Advances in new Materials	",
    unitLoad: "2",
    category: ["material", "unitload2", "compulsory"],
    img: Img29,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },

  {
    courseCode: "PHY 849.2	",
    courseTitle: "Research project	",
    unitLoad: "6",
    category: ["material", "unitload6", "compulsory"],
    img: Img47,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 851.2	",
    courseTitle: "Management and entrepreneurship		",
    unitLoad: "2",
    category: ["material", "unitload2", "compulsory"],
    img: Img40,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 850.1		",
    courseTitle: "ICT and research methodology		",
    unitLoad: "2",
    category: ["environment", "unitload2", "compulsory"],
    img: Img12,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 801.1		",
    courseTitle: "Mathematical Physics	",
    unitLoad: "3",
    category: ["environment", "unitload3", "compulsory"],
    img: Img35,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 861.1		",
    courseTitle: "Atmospheric physics and meteorology	",
    unitLoad: "3",
    category: ["environment", "unitload3", "compulsory"],
    img: Img67,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 862.1		",
    courseTitle: "Fundamentals of Nuclear physics		",
    unitLoad: "3",
    category: ["environment", "unitload3", "compulsory"],
    img: Img64,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 863.1		",
    courseTitle: "Radiation, Detection, Dosimetry and radiation protection	",
    unitLoad: "3",
    category: ["environment", "unitload3", "compulsory"],
    img: Img57,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 864.1	",
    courseTitle: "Environmental sciences and modelling	",
    unitLoad: "3",
    category: ["environment", "unitload3", "compulsory"],
    img: Img19,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 851.2	",
    courseTitle: "Management and entrepreneurship	",
    unitLoad: "2",
    category: ["environment", "unitload2", "compulsory"],
    img: Img40,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 865.2		",
    courseTitle: "Physics of fluid and water resource management	",
    unitLoad: "3",
    category: ["environment", "unitload3", "compulsory"],
    img: Img55,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 866.2		",
    courseTitle: "Nuclear application in medicine		",
    unitLoad: "3",
    category: ["environment", "unitload3", "compulsory"],
    img: Img64,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 868.			",
    courseTitle: "Seminar in Environmental innovations and nuclear issues	",
    unitLoad: "2",
    category: ["environment", "unitload2", "compulsory"],
    img: Img29,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 869.2	",
    courseTitle: "Research Project work	",
    unitLoad: "6",
    category: ["environment", "unitload6", "compulsory"],
    img: Img47,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 852.1	",
    courseTitle: "Non ionizing Radiation	",
    unitLoad: "2",
    category: ["environment", "unitload2", "elective"],
    img: Img86,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 853.2	",
    courseTitle: "Soil mechanics and properties	",
    unitLoad: "2",
    category: ["environment", "unitload2", "elective"],
    img: Img87,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 813.1	",
    courseTitle: "Electronic instrumentation	",
    unitLoad: "3",
    category: ["environment", "unitload3", "elective"],
    img: Img79,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 867.2	",
    courseTitle: "Introduction to Environmental Technology	",
    unitLoad: "2",
    category: ["environment", "unitload2", "elective"],
    img: Img50,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 900.1	",
    courseTitle: "MATHEMATICAL PHYSICS & MODELING	",
    unitLoad: "3",
    category: ["phd", "unitload3", "compulsory"],
    img: Img35,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 901.1	",
    courseTitle: "PROPOSAL/ TECHNICAL WRITING		",
    unitLoad: "3",
    category: ["phd", "unitload3", "compulsory"],
    img: Img50,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 902.1	",
    courseTitle: "RESEARCH PROJECT (DISSERTATION)		",
    unitLoad: "3",
    category: ["phd", "unitload3", "compulsory"],
    img: Img47,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 903.1		",
    courseTitle: "GLOBAL GEOPHYSICS	",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img75,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 904.1			",
    courseTitle: "CURRENT ADVANCES IN APPLIED GEOPHYSICS		",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img44,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 905.1				",
    courseTitle: "GEOPHYSICAL EXPLORATION			",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img45,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 906.1			",
    courseTitle: "SPECIAL PHYSICS (MICROWAVE, FIBRE OPTICS, TELECOM)		",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img88,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 907.1				",
    courseTitle: "CURRENT TRENDS IN SEMICONDUCTOR ELECTRONICS			",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img58,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 908.1	",
    courseTitle: "RECENT ADVANCES IN MATERIAL SCIENCE				",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img81,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 909.1	",
    courseTitle: "CORROSION SCIENCE AND MATERIALS DEGRADATION			",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img89,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 910.1		",
    courseTitle: "CURRENT ADVANCES IN THEORITICAL PHYSICS		",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img66,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 911.1		",
    courseTitle: "ADVANCES IN SOLID STATE PHYSICS		",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img3,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 912.1	",
    courseTitle: "CURRENT TRENDS IN ENVIREONMENTAL PHYSICS	",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img56,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 913.1	",
    courseTitle: "ENVIRONMENTAL POLICIES & STANDARDS	",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img56,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
  {
    courseCode: "PHY 914.1		",
    courseTitle: "ENVIRONMENTAL TECHNOLOGY & CLIMATE CHANGE	",
    unitLoad: "3",
    category: ["phd", "unitload3", "elective"],
    img: Img90,
    courseDetail:
      "Students study the laws of thermodynamics, entropy, and statistical mechanics, which explain the behavior of systems with many particles.",
    courseHandler: "M.S. Nawaz",
  },
];
